const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class MoneyInput {
    constructor(data, placeholder, validator) {
        this.data = data;
        this.element = cELM("div", "option-block");
        this.placeholder = placeholder || "";

        this.validator = validator;
        this.elements = null;
    }

    getELM() {
        return this.element;
    }

    setAutoFocus(v) {
        this._autofocus = v;
    }

    getHTML() {
        const _self = this;
        const inputEl = cELM("input", "number-input mr");
        inputEl.type = "number";
        inputEl.placeholder = this.placeholder;

        if (typeof this._autofocus === 'undefined' || this._autofocus) {
            inputEl.autofocus = true;
        }

        inputEl.onkeydown = function (evt) {
            // disable inputing "e"
            return evt.keyCode !== 69;
        };

        const buttonEl = cELM("div", "go-button", getLngTxt("button.submit"));
        buttonEl.onclick = function (evt) {
            if (!buttonEl.classList.contains('go-button-active') || (inputEl.value || '').length <= 0) {
                return;
            }

            const op = inputEl.value;
            inputEl.blur();
            inputEl.classList.remove("invalid");

            if (_self.validator && !_self.validator(op)) {
                inputEl.classList.add("invalid");
                inputEl.focus();
                return;
            }

            if (window.__FN_DATA_WRAPPER) {
                Chat.default.send(window.__FN_DATA_WRAPPER(op), null, _self.element);
            } else {
                Chat.default.send(op, null, _self.element);
            }
        };

        const fnChange = function (evt) {
            if (evt.key === "Enter") {
                buttonEl.click();
            }

            setTimeout(() => {
                if (inputEl.value.length > 0) {
                    buttonEl.classList.add("go-button-active");
                } else {
                    buttonEl.classList.remove("go-button-active");
                }
            }, 10);
        };

        inputEl.onkeyup = fnChange;
        inputEl.onchange = fnChange;

        const span = cELM("span", "money-input-wrapper");
        span.addELM(inputEl);

        this.element.addELM(Wrap4Arrow(span, true));
        this.element.addELM(buttonEl);
        this.elements = { el: inputEl, btn: buttonEl };

        return this.element;
    }

    reset() {
        this.element.firstChild.value = "";
        this.element.firstChild.focus();
    }

    focus() {
        // this.elements.el.click();
        //this.elements.el.focus();
    }
}

module.exports = MoneyInput;